import { render, staticRenderFns } from "./KioskClassesView.vue?vue&type=template&id=ae34252e&"
import script from "./KioskClassesView.vue?vue&type=script&lang=js&"
export * from "./KioskClassesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports